import React, { FC, ReactElement, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { buttonProps } from './Botton';
import { ButtonElement } from './Botton';
import elementsClassInstance from '../Elements';

type buttonEditorProps = {}

type EditorProps = buttonProps & buttonEditorProps;


const ButtonEditorElement = styled(ButtonElement)`
    .buttonWrapper {
        transition: width 0s linear !important;
        text-align: center;
    }
`;

const ButtonEditor: FC<EditorProps> = ({ ...props }): ReactElement => {

    const buttonTitle = '<span>' + props.title + '</span>';
    const buttonDefaultTitle = '<span>Click Here</span>';
    let elementObject = elementsClassInstance.getElement('RichText');
    const RichText = elementObject[ 'RichText' ];
    const trackStory = props.editorPlugins.trackStory;
    const useAppDispatch = props.editorPlugins.useAppDispatch;
    const dispatch = useAppDispatch();
    const ResizeAxis = props.editorPlugins?.ResizeAxis;

    // ======= resize ========
    const elementRef = useRef<HTMLAnchorElement | null>(null);
    const [ width, setWidth ] = useState<string>(props.width);
    const [ elementDomWidth, setElementDomWidth ] = useState<number>(0);
    const [ containerWidth, setContainerWidth ] = useState<number>(0);
    useEffect(() => { setWidth(props.width) }, [ props.width ]);
    const emitWidth = (width: number): void => setWidth(String(width));

    useEffect(() => {
        if (elementRef && elementRef.current) setContainerWidth(elementRef.current.clientWidth);
        if (elementRef && elementRef.current) {
            const richText: HTMLDivElement | null = elementRef.current.closest('.Button');
            if (richText) setElementDomWidth(richText.clientWidth);
        }
    }, [ width ]);
    // ======= resize end ========

    function clickEditButtonText() {
        dispatch(trackStory({ event: 'click button to edit text', screen: 'editorv4', params: {} }));
    }

    return (
        <ButtonEditorElement className={'buttonElement'} color={props.color} background={props.background}
            colorHover={props.colorHover} backgroundHover={props.backgroundHover} round={props.round} fontSize={props.fontSize}
            horizontalAlignment={props.horizontalAlignment} borderWidth={props.borderWidth} borderColor={props.borderColor} width={width} isBold={props.isBold}
            borderColorHover={props.borderColorHover}>
            {
                props.width && ResizeAxis && <ResizeAxis
                    widthProps={{ width: String(width || 100), property: "width", min: 10, max: 100, elementDomWidth, containerWidth, emitWidth }}
                    heightProps={{ height: 0, property: '', containerHeight: 0, emitHeight: () => { } }}
                    containerHeight={elementRef.current?.offsetHeight}
                />
            }
            <a className={'buttonWrapper'} href={props.url} onClick={() => clickEditButtonText()} ref={elementRef}>
                <RichText editorPlugins={props.editorPlugins} path={props.path} content={buttonTitle} defaultContent={buttonDefaultTitle} isButton={true}></RichText>
            </a>
        </ButtonEditorElement>
    );
};

// Set default props

export default ButtonEditor;
